import type { FunnelStep } from "schemas/generated/funnelStep";

export const transformStepToFile = ({
  step,
  index,
}: {
  step: FunnelStep;
  index: number;
}) => {
  return {
    ...step.file,
    route: step.file?.pageRoute ?? "",
    name: step.file?.name ?? `Page ${index + 1}`,
    id: step.file?.id ?? "",
  };
};
